import dayjs from 'dayjs';

export const convertDateToGMTMinus3 = (datetime) => {
  return dayjs(datetime).subtract(3, 'hour').format('YYYY-MM-DD HH:mm:ss');
};